import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { history } from '../store'

import MachineStatusBadge from './MachineStatusBadge'
import MachineCashBadge from './MachineCashBadge'
import { getMachineCash, getMachineCashColor } from '../utils/machines'
import { addUniversalUpdateSingleParameters, addUniversalUpdateSingleReboot } from '../actions/universalupdates'
import '../styles/MachinesAdminView.css'

class MachineList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      parametersConfirmShown: false,
      rebootConfirmShown: false,
      machineId: null,
      filterOpen: true,
      filters: {
        serial: '',
        customer: '',
        status: '',
        biller: '',
        pay: '',
      },
    };

    this.updateParameters = this.updateParameters.bind(this)
    this.rebootMachine = this.rebootMachine.bind(this)

    this.parametersConfirmShow = this.parametersConfirmShow.bind(this)
    this.parametersConfirmToggle = this.parametersConfirmToggle.bind(this)
    this.rebootConfirmShow = this.rebootConfirmShow.bind(this)
    this.rebootConfirmToggle = this.rebootConfirmToggle.bind(this)
    this.toggleFilter = this.toggleFilter.bind(this)
  }

  goTo(id, e) {
    history.push(`/machines/${id}`)
  }

  handleFilterChange(filterKey, value) {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [filterKey]: value,
      },
    }));
  }

  renderLanguages(languages) {
    if (!Array.isArray(languages) || languages.length === 0) return '—'
    return (
      <div className="mach-admin-langs-container">
        <div className="mach-admin-lang-row display">
          <div className="lang-flags-group">
            {languages.slice(0, 4).map((lang, i) => {
              const languageCode = (lang?.Language || 'es_ES').split('_')[0]
              return (
                <img
                  key={i}
                  className="lang-flag-img"
                  src={`/languages/${languageCode.toLowerCase()}.png`}
                  alt={lang?.Language || 'es_ES'}
                />
              )
            })}
          </div>
        </div>
      </div>
    )
  }

  handleParametersClick = (machine, event) => {
    event.stopPropagation();
    if (machine.Status !== 'OPERATIVE') {
      alert("Acción bloqueada! La máquina no está online.");
    } else {
      this.parametersConfirmShow(machine._id);
    }
  }

  updateParameters() {
    const { addUniversalUpdateSingleParameters } = this.props

    addUniversalUpdateSingleParameters(this.state.machineId)
    this.parametersConfirmToggle()
  }

  parametersConfirmShow(id) {
    this.setState({
      parametersConfirmShown: true,
      machineId: id
    })
  }

  parametersConfirmToggle() {
    this.setState({ parametersConfirmShown: !this.state.parametersConfirmShown })
  }

  getUpdaterStatus(lastUpdaterSignal) {
    if (!lastUpdaterSignal) return "🟢"; // Default to red if no signal

    const lastSignalDate = new Date(lastUpdaterSignal);
    const now = new Date();
    const diffInMinutes = (now - lastSignalDate) / (1000 * 60);

    return diffInMinutes > 60 ? "🟢" : "🟢";
  }

  handleRebootClick = (machine, event) => {
    event.stopPropagation();
    if (machine.Status !== 'OPERATIVE') {
      alert("Acción bloqueada! La máquina no está online.");
    } else {
      this.rebootConfirmShow(machine._id);
    }
  }

  rebootMachine() {
    const { addUniversalUpdateSingleReboot } = this.props

    addUniversalUpdateSingleReboot(this.state.machineId)
    this.rebootConfirmToggle()
  }

  rebootConfirmShow(id) {
    this.setState({
      rebootConfirmShown: true,
      machineId: id
    })
  }

  rebootConfirmToggle() {
    this.setState({ rebootConfirmShown: !this.state.rebootConfirmShown })
  }

  toggleFilter() {
    this.setState(prev => ({ filterOpen: !prev.filterOpen }))
  }

  getPayments(tipo) {

    switch (tipo) {
      case 0: {
        return "TPV + CASH"
      }
      case 1: {
        return "CASH"
      }
      case 2: {
        return "TPV"
      }
      case 3: {
        return "RFID"
      }
      case 4: {
        return "GRATIS"
      }
    }

  }

  render() {
    const { filters, filterOpen } = this.state
    const { machines, auth, role } = this.props;

    // Apply the filters to filter the machines array
    const filteredMachines = machines.filter(machine => {
      const { serial, customer, status, biller, pay } = filters;

      // Apply the Serial filter
      if (serial && !machine.Serial.includes(serial)) {
        return false;
      }

      // Apply the Customer filter
      if (
        customer &&
        (!machine.Customer ||
          !machine.Customer.Fullname.toLowerCase().includes(customer.toLowerCase()))
      ) {
        return false;
      }

      // Apply the Status filter
      if (
        status &&
        (!machine.Status ||
          !machine.Status.toLowerCase().includes(status.toLowerCase()))
      ) {
        return false;
      }

      // Apply the Biller filter
      if (
        biller &&
        (!getMachineCash(machine).toLowerCase().includes(biller.toLowerCase()))
      ) {
        return false;
      }

      // Apply the Pay filter
      if (
        pay &&
        machine.PaymentMethods !== parseInt(pay, 10)) {
        return false;
      }

      // If all conditions pass, include the machine in the filtered list
      return true;
    });

    return (
      <div>
        {/* Collapsible Filter Panel */}
        <div className="mach-admin-filter-card">
          <div className="mach-admin-filter-header" onClick={this.toggleFilter}>
            <h3><i className="fas fa-filter"></i> Filtros</h3>
            <i className={`fas fa-chevron-down toggle-icon ${filterOpen ? 'open' : ''}`}></i>
          </div>
          {filterOpen && (
            <div className="mach-admin-filter-body">
              <div className="filter-grid">
                <div className="filter-group">
                  <label htmlFor="filter-serial">Identificador</label>
                  <input
                    id="filter-serial"
                    type="text"
                    placeholder="Buscar por serial..."
                    value={filters.serial}
                    onChange={(e) => this.handleFilterChange('serial', e.target.value)}
                  />
                </div>
                <div className="filter-group">
                  <label htmlFor="filter-customer">Cliente</label>
                  <input
                    id="filter-customer"
                    type="text"
                    placeholder="Buscar por cliente..."
                    value={filters.customer}
                    onChange={(e) => this.handleFilterChange('customer', e.target.value)}
                  />
                </div>
                <div className="filter-group">
                  <label htmlFor="filter-status">Estado</label>
                  <select
                    id="filter-status"
                    value={filters.status}
                    onChange={(e) => this.handleFilterChange('status', e.target.value)}
                  >
                    <option value="">Todos</option>
                    <option value="OPERATIVE">ONLINE</option>
                    <option value="OFFLINE">OFFLINE</option>
                    <option value="SLEEP">SLEEP</option>
                    <option value="NIGHT_SCAN">NIGHTSCAN</option>
                    <option value="MAINTENANCE">MANTENIMIENTO</option>
                    <option value="LOCKERS_FULL">LOCKERS LLENOS</option>
                    <option value="TICKET_EMPTY">SIN TICKET</option>
                  </select>
                </div>
                <div className="filter-group">
                  <label htmlFor="filter-pay">Tipo de Pago</label>
                  <select
                    id="filter-pay"
                    value={filters.pay}
                    onChange={(e) => this.handleFilterChange('pay', e.target.value)}
                  >
                    <option value="">Todos</option>
                    <option value="0">TPV + CASH</option>
                    <option value="1">CASH</option>
                    <option value="2">TPV</option>
                    <option value="3">RFID</option>
                    <option value="4">GRATIS</option>
                  </select>
                </div>
                <div className="filter-group">
                  <label htmlFor="filter-biller">Billetero</label>
                  <select
                    id="filter-biller"
                    value={filters.biller}
                    onChange={(e) => this.handleFilterChange('biller', e.target.value)}
                  >
                    <option value="">Todos</option>
                    <option value="OK">OK</option>
                    <option value="FULL">FULL</option>
                  </select>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Column Headers */}
        <div className="mach-admin-list-header">
          <div className="mach-header-col col-id">Identificador</div>
          <div className="mach-header-col col-customer">Cliente</div>
          <div className="mach-header-col col-status">Estado</div>
          <div className="mach-header-col col-langs">Idiomas</div>
          <div className="mach-header-col col-passwords">Contraseñas</div>
          {role === 'ADMIN' && <div className="mach-header-col col-versions">Versiones</div>}
          <div className="mach-header-col col-payments">Pagos</div>
          <div className="mach-header-col col-pc">PC</div>
          {(auth.type !== 'LIMITED' && role === 'ADMIN') && (
            <div className="mach-header-col col-actions">Acciones</div>
          )}
        </div>

        {/* Machine Cards */}
        <div className="mach-admin-machine-list">
          {filteredMachines.length > 0 ? (
            filteredMachines.map((machine) => {
              const statusClass = machine.Status || 'UNKNOWN'
              return (
                <div
                  key={machine._id}
                  className="mach-admin-machine-card"
                  onClick={(e) => this.goTo(machine._id, e)}
                >
                  <div className="mach-admin-machine-row">
                    <div className={`mach-admin-status-bar ${statusClass}`}></div>
                    <div className="mach-admin-machine-content">

                      {/* Machine ID */}
                      <div className="mach-admin-machine-id">
                        <div className="mach-admin-serial">{machine.Serial}</div>
                      </div>

                      {/* Customer */}
                      <div className="mach-admin-machine-customer notranslate">
                        <div className="mach-admin-customer-name">
                          {(machine.Customer && machine.Customer.Fullname) || 'None'}
                        </div>
                      </div>

                      {/* Status */}
                      <div className="mach-admin-machine-status">
                        <MachineStatusBadge machine={machine} />
                        <div className="mach-admin-status-line">
                          <i className="fas fa-clock"></i>
                          {machine.Last_signal ? new Date(machine.Last_signal).toLocaleString() : '—'}
                        </div>
                        <div className="mach-admin-status-line">
                          <span className="status-label">Sleep:</span>
                          {`${machine.SleepStart?.substring(0, 2) || '--'}:${machine.SleepStart?.substring(2) || '--'} - ${machine.SleepEnd?.substring(0, 2) || '--'}:${machine.SleepEnd?.substring(2) || '--'}`}
                        </div>
                        <div className="mach-admin-status-line">
                          <span className="status-label">Updater:</span>
                          {this.getUpdaterStatus(machine.Last_updater_signal)}
                        </div>
                      </div>

                      {/* Languages */}
                      <div className="mach-admin-machine-langs">
                        {this.renderLanguages(machine.SupportedLanguages)}
                      </div>

                      {/* Passwords */}
                      <div className="mach-admin-machine-passwords">
                        <div className="mach-admin-pwd-item">
                          <i className="fas fa-cogs"></i>
                          <span className="pwd-label">Máquina:</span>
                          <span className="pwd-value">{machine.PasswordMachine}</span>
                        </div>
                        <div className="mach-admin-pwd-item">
                          <i className="fas fa-money-bill-wave"></i>
                          <span className="pwd-label">Cash:</span>
                          <span className="pwd-value">{machine.PasswordCash}</span>
                        </div>
                      </div>

                      {/* Versions */}
                      {role === 'ADMIN' && (
                        <div className="mach-admin-machine-versions">
                          <div className="mach-admin-version-item">
                            <span className="label">SW:</span>
                            <span className="value">{machine.Sw_version}</span>
                          </div>
                          <div className="mach-admin-version-item">
                            <span className="label">FW:</span>
                            <span className="value">{machine.Fw_version}</span>
                          </div>
                          <div className="mach-admin-version-item">
                            <span className="label">UP:</span>
                            <span className="value">{machine.Up_version}</span>
                          </div>
                          <div className="mach-admin-version-item">
                            <span className="label">Sale:</span>
                            <span className="value">{machine.LastSale}</span>
                          </div>
                        </div>
                      )}

                      {/* Payments */}
                      <div className="mach-admin-machine-payments">
                        <div className="mach-admin-payment-type">
                          {this.getPayments(machine.PaymentMethods)}
                        </div>
                        {(machine.PaymentMethods === 0 || machine.PaymentMethods === 1) && (
                          <MachineCashBadge machine={machine} />
                        )}
                      </div>

                      {/* PC Info */}
                      <div className="mach-admin-machine-pc">
                        <div className="mach-admin-pc-line temp">{machine.CoreTemp}</div>
                        <div className="mach-admin-pc-line mono">{machine.Anydesk}</div>
                        <div className="mach-admin-pc-line mono">{machine.IP}</div>
                        <div className="mach-admin-os-badge">
                          <i className="fa-brands fa-raspberry-pi"></i>
                          Raspbian
                        </div>
                      </div>

                      {/* Actions */}
                      {(auth.type !== 'LIMITED' && role === 'ADMIN') && (
                        <div className="mach-admin-machine-actions">
                          <button
                            className="mach-admin-card-action-btn update"
                            onClick={(event) => this.handleParametersClick(machine, event)}
                          >
                            <i className="fas fa-database"></i>
                            Actualizar
                          </button>
                          <button
                            className="mach-admin-card-action-btn reboot"
                            onClick={(event) => this.handleRebootClick(machine, event)}
                          >
                            <i className="fas fa-plug"></i>
                            Reiniciar
                          </button>
                        </div>
                      )}

                    </div>
                  </div>
                </div>
              )
            })
          ) : (
            <div className="mach-admin-empty">
              <i className="fas fa-server"></i>
              <p>No se encontraron máquinas</p>
            </div>
          )}
        </div>

        {/* Modals */}
        <div>
          <Modal isOpen={this.state.parametersConfirmShown}
            toggle={this.parametersConfirmToggle}>
            <ModalHeader toggle={this.parametersConfirmToggle}>
              Confirmar
            </ModalHeader>
            <ModalBody>
              <p>¿Estás seguro de actualizar los parámetros?</p>
              <br></br>
              <p>-La máquina se actualizará interrumpiendo los procesos y saldrá un mensaje en pantalla para reiniciar la máquina una vez finalizado el proceso.</p>
            </ModalBody>
            <ModalFooter>
              <Button color="primary mr-1" onClick={this.updateParameters}>
                Actualizar
              </Button>
              <Button color="secondary" onClick={this.parametersConfirmToggle}>
                Cancelar
              </Button>
            </ModalFooter>
          </Modal>
        </div>
        <div>
          <Modal isOpen={this.state.rebootConfirmShown}
            toggle={this.rebootConfirmToggle}>
            <ModalHeader toggle={this.rebootConfirmToggle}>
              Confirmar
            </ModalHeader>
            <ModalBody>
              <p>¿Estás seguro de reiniciar la máquina?</p>
              <br></br>
              <p>-La máquina se reiniciará interrumpiendo los procesos.</p>
            </ModalBody>
            <ModalFooter>
              <Button color="primary mr-1" onClick={this.rebootMachine}>
                Reiniciar
              </Button>
              <Button color="secondary" onClick={this.rebootConfirmToggle}>
                Cancelar
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  role: state.auth.role,
  type: state.auth.type,
  fullname: state.auth.fullname,
})

const mapDispatchToProps = dispatch => ({
  addUniversalUpdateSingleParameters: bindActionCreators(addUniversalUpdateSingleParameters, dispatch),
  addUniversalUpdateSingleReboot: bindActionCreators(addUniversalUpdateSingleReboot, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(MachineList)